import React from "react";
import LogoImage from "../assets/logo.png";
import { whatsappLink, WHATSAPP_MESSAGES } from "../utils/whatsapp";

export default function Footer() {
  return (
    <footer className="bg-[#1c1c1c] border-t border-pink-500/20">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 xl:px-12 pt-12 pb-5">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

          {/* Logo */}
          <div className="flex flex-col items-start">
            <img
              src={LogoImage}
              alt="Kinews Studio Logo"
              className="w-62 h-20 mb-3"
            />

            {/* subtle accent line */}
            <div className="mt-2 h-[2px] w-12 bg-pink-500/60"></div>

            <p className="mt-4 text-sm leading-relaxed text-white/70 md:max-w-xs">
              Professional photography studio in Rochdale, Greater Manchester.
              Portraits, events, studio hire and printing.
            </p>
          </div>

          {/* Opening Hours */}
          <div>
            <h4 className="font-bold text-white mb-3">
              Opening Hours
            </h4>

            <ul className="space-y-2 text-white/70 text-sm">
              <li>Monday: 9am - 6pm</li>
              <li>Tuesday: 9am - 6pm</li>
              <li>Wednesday: 9am - 6pm</li>
              <li>Thursday: 9am - 6pm</li>
              <li>Friday: 9am - 6pm</li>
              <li>Saturday: 9am - 6pm</li>
              <li>Sunday: Closed</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-white mb-3">
              Get in touch
            </h4>

            <ul className="text-white/70 text-sm space-y-2">
              <li>
                Unit 2, Beechwood House, Milnrow Road, Rochdale, Manchester OL16 2AA
              </li>

              <li className="hover:text-pink-400 transition">
                +44 7486 160965, &nbsp; 01706 803 538
              </li>

              <li className="hover:text-pink-400 transition break-words">
                info@kinewsstudiolimited.co.uk
              </li>
            </ul>

            {/* Social Icons */}
            <div className="flex gap-4 mt-6 text-white">
              <a
                href="https://www.instagram.com/kinewsstudioltd"
                className="hover:text-pink-500 transition text-base"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i>
              </a>

              <a
                href="https://web.facebook.com/profile.php?id=100064556025543&locale=mt_MT#"
                className="hover:text-pink-500 transition text-base"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook"></i>
              </a>

              <a
                href="https://www.tiktok.com/@kinewsstudio.co.uk"
                className="hover:text-pink-500 transition text-base"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-tiktok"></i>
              </a>

              <a
                href="https://www.youtube.com/channel/UCNEY7P-m85b--rapXa8Zncg"
                className="hover:text-pink-500 transition text-base"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-youtube"></i>
              </a>

              <a
                href={whatsappLink(WHATSAPP_MESSAGES.general)}
                className="hover:text-pink-500 transition text-base"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-8 pt-5 border-t border-pink-500/10 text-xs text-white/60 flex flex-col sm:flex-row items-center justify-center gap-3">
          <p>
            © {new Date().getFullYear()} Kinews Studio Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}